<template>
  <el-config-provider :locale="locale">
    <router-view />
    <el-dialog modal-class="close-modal" v-model="visible" :title="null" width="600px" :show-close="false" align-center :close-on-click-modal="false">
      <div style="text-align: center; color: #000; font-size: 14px">
        {{ event.CloseMessage || '当前活动已关闭' }}
      </div>
    </el-dialog>
  </el-config-provider>
</template>

<script setup>
  import { useAppStore } from '@/store/modules/app'
  import { storeToRefs } from 'pinia'
  import { provide, computed, ref, onMounted } from 'vue'

  import { enLocale, zhLocale } from '@/i18n/index'
  import { useI18n } from 'vue-i18n'
  import { ElMessageBox, ElLoading } from 'element-plus'
  import { login } from '@/api/registration'
  import { useUserStore } from '@/store/modules/user'
  import { useRouter, useRoute } from 'vue-router'

  import { useWxShare } from '@/hooks/useWxShare'

  const route = useRoute()
  const router = useRouter()
  const { locale: language } = useI18n()

  const locale = computed(() => (language.value === 'zh-CN' ? zhLocale : enLocale))
  const $language = computed(() => (language.value === 'zh-CN' ? 0 : 1))
  //
  const { event, config, openid, isWeixin } = storeToRefs(useAppStore())
  const visible = ref(false)
  provide('$event', event.value)
  provide('$config', config.value)
  provide('$language', $language)
  onMounted(async () => {
    // if (event.value.IsClose&&!(route.name === 'confirmation' || route.name === 'personalcenter-confirmation')) {
    //   visible.value  = true
    // } else 
    if ((event.value.Status || '').toLocaleLowerCase() === 'pending') {
      ElMessageBox.alert(
        ['您生成的活动需等待管理员审核，审核后活动可以发布，请等待审核。', "The event will be reviewed by the supervisor. The link can be published once it's been approved. Thank you."][
          $language.value
        ],
        '',
        {
          confirmButtonText: 'OK',
          callback: (action) => {},
        }
      )
    } else {
      //
      if (isWeixin.value && openid.value && route.name === 'index' && event.value.Config.Wechat) {
        let loading = ElLoading.service({ fullscreen: true })
        try {
          const { data } = await login({}, { type: 'sso' })
          console.log(data)

          loading.close()
          if (data && data.uid && data.access_token && data.to !== route.name) {
            const { setToken } = useUserStore()
            setToken(data)
            router.push({ name: data.to })
          }
        } catch (e) {
          loading.close()
        }
      }
    }
    handleWXJSSDK()
  })

  const handleWXJSSDK = () => {
    useWxShare(window.location.href.split('#')[0], {
      title: event.value.EventName,
      desc: event.value.StartDate + '\n' + event.value.Address,
      imgUrl: event.value.Banner || event.value.Logo,
      link: window.location.href, //.split('#')[0].replace(/\/$/, '') + '/#/',
    })
  }

  //
</script>

<style lang="scss">
  .close-modal {
    background-color: rgba(0, 0, 0, 0.6) !important;
    .el-dialog {
      border-radius: 4px;
      width: calc(100% - 24px);
      max-width: 660px;
    }
    .el-dialog__header {
      display: none;
    }
  }
</style>